<template>
    <svg width="94px" height="94px" viewBox="0 0 94 94" class="searchSVG">
        <defs>
            <path
                id="search-path-1"
                d="M83.0193452,86.1666667 C83.8936012,86.1666667 84.6512897,85.875248 85.2924107,85.2924107 C85.875248,84.6512897 86.1666667,83.8936012 86.1666667,83.0193452 C86.1666667,82.1450893 85.875248,81.3874008 85.2924107,80.7462798 L67.2827381,62.8240327 C72.4117063,56.5876736 74.9761905,49.4479167 74.9761905,41.4047619 C74.9761905,32.1376488 71.6977307,24.2256324 65.140811,17.6687128 C58.5838914,11.1117932 50.671875,7.83333333 41.4047619,7.83333333 C32.1376488,7.83333333 24.2256324,11.1117932 17.6687128,17.6687128 C11.1117932,24.2256324 7.83333333,32.1376488 7.83333333,41.4047619 C7.83333333,50.671875 11.1117932,58.5838914 17.6687128,65.140811 C24.2256324,71.6977307 32.1376488,74.9761905 41.4047619,74.9761905 C49.4479167,74.9761905 56.5876736,72.4117063 62.8240327,67.2827381 L80.8337054,85.2924107 C81.4165427,85.875248 82.1450893,86.1666667 83.0193452,86.1666667 Z M41.4047622,68.6815485 C37.6746034,68.6815485 34.1484377,67.9821437 30.826265,66.5833342 C27.5623761,65.1845246 24.6627604,63.2174487 22.1274181,60.6821064 C19.5920758,58.1467641 17.6541417,55.2471484 16.3136159,51.9832595 C14.8565226,48.6610868 14.127976,45.134921 14.127976,41.4047622 C14.127976,37.6746034 14.8565226,34.1484377 16.3136159,30.826265 C17.6541417,27.5623761 19.5920758,24.6627604 22.1274181,22.1274181 C24.6627604,19.5920758 27.5623761,17.6249999 30.826265,16.2261903 C34.1484377,14.8273808 37.6746034,14.127976 41.4047622,14.127976 C45.134921,14.127976 48.6610868,14.8273808 51.9832595,16.2261903 C55.2471484,17.6249999 58.1467641,19.5920758 60.6821064,22.1274181 C63.2174487,24.6627604 65.1845246,27.5623761 66.5833342,30.826265 C67.9821437,34.1484377 68.6815485,37.6746034 68.6815485,41.4047622 C68.6815485,45.134921 67.9821437,48.6610868 66.5833342,51.9832595 C65.1845246,55.2471484 63.2174487,58.1467641 60.6821064,60.6821064 C58.1467641,63.2174487 55.2471484,65.1845246 51.9832595,66.5833342 C48.6610868,67.9821437 45.134921,68.6815485 41.4047622,68.6815485 Z"
            ></path>
        </defs>
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons-/-Search-Icons-/-Regular-/-Search">
                <mask id="search-mask-2" fill="white">
                    <use xlink:href="#search-path-1"></use>
                </mask>
                <use id="Mask" fill="#7178A5" fill-rule="nonzero" xlink:href="#search-path-1"></use>
                <g
                    id="Color-/-Grey-Color-/-Purple-/-Regular"
                    mask="url(#search-mask-2)"
                    fill="#5B74FF"
                >
                    <g id="Color-/-Dark-Grey-" transform="translate(-31.333333, -31.333333)">
                        <rect x="0" y="0" width="156.666672" height="156.666672"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'SearchSVG',
};
</script>

<style lang="scss" scoped>
.searchSVG {
    position: absolute;
    top: 67px;
    left: 67px;
}
</style>
